import { FC } from 'react';
import Modal from '../Modal/Modal';

interface AssessmentData {
  [domain: string]: {
    [subdomain: string]: {
      discovery: string;
      foundational: string;
      emerging: string;
      developing: string;
      advancing: string;
      thriving: string;
    };
  };
}

interface LongAssessmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentSubdomain: string;
  currentDomain: string;
  assessmentData: AssessmentData;
}

export const LongAssessmentModal: FC<LongAssessmentModalProps> = ({
  isOpen,
  onClose,
  currentSubdomain,
  currentDomain,
  assessmentData
}) => {
  const domainData = assessmentData[currentDomain];
  const subdomainData = domainData?.[currentSubdomain];

  return (
    <Modal.Wrapper 
      isOpen={isOpen} 
      onClose={onClose}
      showCloseButton
      className="max-w-3xl"
    >
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-6">{currentSubdomain}</h2>
        
        {subdomainData && (
          <div className="space-y-6">
            {Object.entries(subdomainData).map(([stage, description]) => (
              <div key={stage} className="border-b pb-4 last:border-b-0">
                <h3 className="text-lg font-semibold mb-2 capitalize">
                  {stage.replace(/([A-Z])/g, ' $1').trim()}
                </h3>
                <p className="text-gray-700">{description as string}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal.Wrapper>
  );
};

export default LongAssessmentModal;
